import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import OpenerImage from '../common/opener_image';
import OpenerImagesPropTypes from '../../utils/prop-types/OpenerImagesPropTypes';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';

export default class SeriesCard extends PureComponent {
  handleClick = () => {
    sendDataLayerEvent('Click', {
      pageModule: 'Original Series',
      linkURL: this.props.url,
      linkUID: this.props.id,
      linkType: 'video',
      linkTitle: this.props.name,
      linkHeadline: this.props.name,
      itemIndex: this.props.indexWithinRow - 1,
      itemName: this.props.name
    });
    sendAnalyticsEvent(
      `"${this.props.moduleTitle}" Module`,
      'Click',
      this.props.url
    );
  }


  render() {
    const { url, rowType, opener_images, genre, tagline, name } = this.props;

    return (
      <div className="series-card-wrapper">
        <Link to={url} onClick={this.handleClick} className="series card">
          <div className="series-overlay" />
          <div className="series-content">
            <div className="series-watch-now">
              <RosettaFormattedMessage parentFilename={__filename}
                id="watch_now"
                description="Watch Now label that appears on series cards"
                defaultMessage="Watch Now"
              />
            </div>
          </div>
          <OpenerImage
            rowType={rowType}
            opener_images={opener_images}
            alt={name}
          />
        </Link>
        <div className="more-info">
          <div className="show-prop">
            <div dangerouslySetInnerHTML={{ __html: genre }} className="genre" />
          </div>
          {
            tagline &&
            <div dangerouslySetInnerHTML={{ __html: tagline }} className="tagline" />
          }
        </div>
      </div>
    );
  }
}

SeriesCard.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  rowType: PropTypes.string.isRequired,
  opener_images: OpenerImagesPropTypes.isRequired,
  moduleTitle: PropTypes.string.isRequired,
  indexWithinRow: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  genre: PropTypes.string,
  tagline: PropTypes.string
};
